import React from 'react';
import { FlagIcon } from './UI';
export const TopBar = () => {
  return <div className="bg-base-black border-b border-acid-green-border py-2 px-4 text-xs font-barlow tracking-wider flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-0 z-50 relative" data-id="element-1452" data-mp="232wwfjzlaosj">
      <div className="flex items-center text-acid-green" data-id="element-1453" data-mp="1t4pjrdcc2swc">
        <span className="w-2 h-2 rounded-full bg-acid-green animate-pulse mr-2" data-id="element-1454" data-mp="1t6aep42k8duq"></span>
        OPERATIONAL — UNITS DEPLOYING NOW
      </div>

      <div className="flex items-center space-x-4 text-text-dimmed hidden md:flex" data-id="element-1455" data-mp="2ltekhb9h8w7k">
        <span className="text-white" data-id="element-1456" data-mp="2lvr2tpj5d8l5">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
        <span data-id="element-1457" data-mp="2h0bsh7kcluth">|</span>
        <span data-id="element-1458" data-mp="2c3v6aiwplqj1">BUILT BY OPERATORS. FOR OPERATORS.</span>
        <span data-id="element-1459" data-mp="2c3blmufoco1b">|</span>
        <span className="flex items-center gap-2" data-id="element-1460" data-mp="2c1qyvqzlq9e0">
          <FlagIcon className="w-4 h-3" data-id="element-1461" data-mp="39jr3pia6afdg" /> AMERICAN MADE
        </span>
      </div>

      <div className="flex items-center gap-2 text-text-dimmed sm:hidden" data-id="element-1462" data-mp="34rz9mxrt5rik">
        <span className="text-white" data-id="element-1463" data-mp="25hlbtmv1em3">
          FREE SHIPPING ON ALL ORDERS IN THE USA
        </span>
      </div>
    </div>;
};